export default [
  {
    title: 'breadcrumb.live',
    route: 'list-live',
    icon: '',
    resource: 'bet-setting',
    action: 'read'
  }
];